var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_188",
    "data-name": "Ret\\xE2ngulo 188",
    width: 58,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "union-pay",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "union"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_196",
    "data-name": "Ret\\xE2ngulo 196",
    stroke: "#e7e7e7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 40,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "UnionPay_logo",
    "data-name": "UnionPay logo",
    transform: "translate(7.975 6.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M371.214,418.645h10.748a2.1,2.1,0,0,1,2.082,2.72l-5,21.48a3.652,3.652,0,0,1-3.356,2.726H364.94a2.092,2.092,0,0,1-2.084-2.726l5-21.48a3.64,3.64,0,0,1,3.352-2.73",
    transform: "translate(-362.757 -418.635)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_202",
    "data-name": "Caminho 202",
    d: "M439.5,418.645h12.358c1.5,0,.824,1.224.472,2.73l-5,21.48c-.35,1.5-.24,2.726-1.744,2.726H433.23a2.088,2.088,0,0,1-2.08-2.726l5-21.49a3.648,3.648,0,0,1,3.354-2.73",
    transform: "translate(-421.195 -418.635)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_203",
    "data-name": "Caminho 203",
    d: "M521.786,418.644H532.53a2.094,2.094,0,0,1,2.084,2.72l-5,21.482a3.649,3.649,0,0,1-3.358,2.724H515.52a2.09,2.09,0,0,1-2.084-2.724l5-21.48a3.646,3.646,0,0,1,3.356-2.73",
    transform: "translate(-491.607 -418.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_204",
    "data-name": "Caminho 204",
    d: "M548.654,527.641h1l.288-.974h-1Zm.816-2.688-.348,1.154a4.93,4.93,0,0,1,.6-.258c.2-.048.524-.088.524-.088l.246-.8Zm.5-1.658-.336,1.108a5.53,5.53,0,0,1,.578-.226,3.568,3.568,0,0,1,.52-.076l.244-.8Zm2.24,0-1.31,4.328h.352l-.272.9h-.36l-.082.278H549.3l.086-.278H546.85l.256-.83h.256l1.328-4.4.266-.888h1.27l-.132.45a2.379,2.379,0,0,1,.66-.328c.322-.084,2.164-.116,2.164-.116l-.274.888Z",
    transform: "translate(-520.269 -507.421)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_205",
    "data-name": "Caminho 205",
    d: "M587.89,522.48h1.358l.016.506c0,.086.064.126.222.126h.276l-.252.836h-.738c-.636.046-.876-.226-.866-.532Z",
    transform: "translate(-555.389 -507.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_206",
    "data-name": "Caminho 206",
    d: "M576.962,536.53h-1.288l.222-.744h1.478l.212-.678H576.13l.252-.838h4.064l-.256.838h-1.36l-.214.678h1.368l-.226.744h-1.484l-.26.314h.6l.144.936a.5.5,0,0,0,.048.2.719.719,0,0,0,.314.05h.182l-.276.912h-.462a2.987,2.987,0,0,1-.322-.014.9.9,0,0,1-.33-.144.446.446,0,0,1-.24-.318l-.144-.934-.67.922a1.154,1.154,0,0,1-.99.512h-.942l.246-.814h.36a.58.58,0,0,0,.264-.076.4.4,0,0,0,.2-.166Z",
    transform: "translate(-544.285 -517.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M486.65,535.83h3.422l-.252.818h-1.37l-.214.7h1.4l-.256.844h-1.4l-.338,1.13c-.042.126.33.144.466.144l.7-.1-.276.936h-1.586a1.527,1.527,0,0,1-.36-.05.376.376,0,0,1-.25-.184.362.362,0,0,1-.086-.364l.454-1.5h-.778l.258-.866h.782l.2-.7h-.78Z",
    transform: "translate(-468.141 -518.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M492.274,522.868h1.4l-.256.854H491.5l-.2.178c-.088.086-.12.05-.236.114a1.4,1.4,0,0,1-.634.164h-.616l.25-.822h.184a.66.66,0,0,0,.316-.048.744.744,0,0,0,.2-.266l.352-.642h1.4Z",
    transform: "translate(-471.457 -507.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M510.921,524.305a2.2,2.2,0,0,1,1.038-.464c.144-.028,1.084-.02,1.084-.02l.144-.468h-1.98Zm1.854.358h-1.962l-.12.4h1.7a1.411,1.411,0,0,1,.258,0Zm-2.542-2.22h1.2l-.174.6a3.483,3.483,0,0,1,.642-.4,6.05,6.05,0,0,1,.866-.188l1.936-.01-.66,2.2a2.524,2.524,0,0,1-.32.732.832.832,0,0,1-.328.3,1.222,1.222,0,0,1-.448.144c-.128.01-.324.014-.6.018h-1.868l-.526,1.74c-.05.172-.074.252-.042.3a.214.214,0,0,0,.178.09l.822-.078-.28.954h-.922a6.408,6.408,0,0,1-.656-.018.719.719,0,0,1-.388-.078c-.086-.074-.218-.174-.214-.276a3.243,3.243,0,0,1,.11-.466Z",
    transform: "translate(-487.408 -507.453)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M528.609,546.972l-.11.528a.731.731,0,0,1-.214.4.863.863,0,0,1-.642.22l-.664.028v.6c0,.17.036.152.064.178a.21.21,0,0,0,.088.052l.2-.01.634-.038-.262.866h-.722a2.275,2.275,0,0,1-1-.112c-.122-.076-.144-.176-.134-.342l.046-2.326h1.154l-.014.474h.276a.4.4,0,0,0,.2-.034.247.247,0,0,0,.08-.122l.112-.37Z",
    transform: "translate(-502.296 -528.434)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M401.1,466.187c-.042.188-.788,3.63-.8,3.63a2.524,2.524,0,0,1-.672,1.514,1.2,1.2,0,0,1-.8.276A.736.736,0,0,1,398,470.9v-.158s.144-.934.144-.938.782-3.136.922-3.55l.014-.046a11.872,11.872,0,0,1-1.814-.024c0,.03-.05.226-.05.226l-.8,3.532-.07.3-.132.98a1.443,1.443,0,0,0,.17.722c.364.638,1.4.732,2,.732a3.881,3.881,0,0,0,1.946-.452,2.9,2.9,0,0,0,1.246-1.946l.09-.35s.8-3.258.944-3.682a.175.175,0,0,1,.012-.046,12.014,12.014,0,0,1-1.534-.024",
    transform: "translate(-391.372 -459.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M439.736,488.118c-.54,0-.732,0-1.364.024l-.024-.046c.056-.24.116-.478.168-.722l.078-.328c.116-.512.232-1.108.246-1.286.01-.11.048-.382-.264-.382a1.054,1.054,0,0,0-.4.126c-.076.272-.23,1.036-.3,1.386-.158.734-.168.818-.238,1.182l-.058.046c-.558,0-.75,0-1.4.024l-.03-.054c.108-.432.214-.878.316-1.312a19.17,19.17,0,0,0,.4-2.236l.05-.036c.626-.088.776-.106,1.452-.244l.058.064-.1.376c.114-.068.222-.138.34-.2a2.117,2.117,0,0,1,.866-.2.74.74,0,0,1,.754.426c.128.306.044.682-.126,1.424l-.088.376c-.174.826-.2.976-.3,1.542Z",
    transform: "translate(-425.541 -474.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_213",
    "data-name": "Caminho 213",
    d: "M467.343,492.979h-.738c-.2,0-.4.012-.7.026l-.024-.026-.02-.028a4.8,4.8,0,0,1,.168-.534,3.5,3.5,0,0,0,.152-.54c.1-.414.152-.7.2-.956s.068-.452.1-.7l.026-.018.028-.024.738-.108c.2-.032.432-.072.762-.136l.012.028V490c-.062.256-.126.512-.186.774s-.122.514-.178.772c-.122.546-.17.748-.2.892s-.036.214-.084.5l-.028.026Z",
    transform: "translate(-450.966 -479.645)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_214",
    "data-name": "Caminho 214",
    d: "M485.385,486.635a2.669,2.669,0,0,1-.318.882.52.52,0,0,1-.4.262c-.044,0-.308,0-.314-.4a2.647,2.647,0,0,1,.086-.614c.144-.63.31-1.154.738-1.154.338,0,.36.4.214,1.024m1.412.06a1.617,1.617,0,0,0-.144-1.458,1.6,1.6,0,0,0-1.3-.474,2.372,2.372,0,0,0-1.626.566,2.673,2.673,0,0,0-.722,1.4c-.116.5-.25,1.426.6,1.766a2.512,2.512,0,0,0,.876.144,2.282,2.282,0,0,0,1.724-.676,3,3,0,0,0,.6-1.266",
    transform: "translate(-465.564 -475.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_215",
    "data-name": "Caminho 215",
    d: "M592.632,488.812c-.652,0-.84,0-1.442.02l-.04-.05c.164-.62.33-1.238.474-1.866a14.129,14.129,0,0,0,.288-1.634l.05-.04c.648-.092.826-.118,1.5-.242l.022.054c-.122.51-.246,1.02-.364,1.532-.25,1.072-.338,1.618-.432,2.178Z",
    transform: "translate(-558.179 -475.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_216",
    "data-name": "Caminho 216",
    d: "M579.325,486.933a2.967,2.967,0,0,1-.322.878.744.744,0,0,1-.524.256c-.044,0-.308,0-.318-.4a2.67,2.67,0,0,1,.09-.614c.144-.616.31-1.142.738-1.142.338,0,.482.384.336,1m1.29.062c.188-.826-.578-.074-.7-.346-.188-.426-.07-1.29-.822-1.576a1.8,1.8,0,0,0-1.546.562,2.665,2.665,0,0,0-.722,1.4c-.116.5-.25,1.416.588,1.746a1.687,1.687,0,0,0,.748.136c.842-.046,1.486-1.318,1.96-1.822.366-.4.432.144.486-.092",
    transform: "translate(-545.85 -475.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_217",
    "data-name": "Caminho 217",
    d: "M514.262,488.16c-.542,0-.722,0-1.364.024l-.024-.046c.054-.24.116-.478.172-.722l.076-.328c.116-.512.232-1.108.246-1.286.01-.11.046-.382-.262-.382a1.055,1.055,0,0,0-.4.126c-.076.272-.23,1.036-.3,1.386-.154.734-.164.818-.236,1.182l-.046.048c-.556,0-.748,0-1.388.024l-.028-.054c.106-.432.21-.878.314-1.312a19.108,19.108,0,0,0,.4-2.236l.044-.03c.624-.088.776-.106,1.452-.244l.054.064-.1.376c.112-.068.224-.138.338-.2a2.109,2.109,0,0,1,.866-.2.746.746,0,0,1,.76.426c.126.306.042.682-.13,1.424l-.086.376c-.178.826-.2.976-.3,1.542Z",
    transform: "translate(-489.331 -474.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_218",
    "data-name": "Caminho 218",
    d: "M545.4,466.077h-.448c-1.168.014-1.638,0-1.83-.016-.02.086-.05.238-.05.238l-.416,1.942s-1,4.126-1.048,4.32c1.02-.012,1.442-.012,1.612,0l.278-1.346s.2-.846.214-.878a.485.485,0,0,1,.128-.122h.092a4.3,4.3,0,0,0,2.652-.578,2.828,2.828,0,0,0,1.054-1.676,2.489,2.489,0,0,0,.074-.586,1.222,1.222,0,0,0-.212-.746c-.4-.556-1.184-.564-2.1-.57m.586,2.02a1.42,1.42,0,0,1-.732.968,2.387,2.387,0,0,1-1.032.16h-.248l.018-.1.444-1.93.012-.1v-.076l.178.018.94.082a.768.768,0,0,1,.4.974",
    transform: "translate(-515.785 -459.211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_219",
    "data-name": "Caminho 219",
    d: "M612.291,484.658l-.052-.058c-.666.132-.788.156-1.4.236l-.046.044a.2.2,0,0,0,0,.028h0c-.458,1.054-.442.826-.816,1.656v-.1l-.106-1.8-.06-.058c-.7.132-.722.156-1.36.236l-.052.044a.185.185,0,0,1-.01.072v.01a8.978,8.978,0,0,1,.144.97c.038.318.086.642.124.956.064.528.1.79.176,1.586-.432.722-.54,1-.954,1.626l.022.058c.63-.024.776-.024,1.244-.024l.1-.116c.352-.76,3.038-5.37,3.038-5.37",
    transform: "translate(-572.498 -475.074)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_220",
    "data-name": "Caminho 220",
    d: "M471.981,482.851c.356-.25.4-.6.1-.772a1.228,1.228,0,0,0-1.2.126c-.36.25-.4.6-.1.77a1.22,1.22,0,0,0,1.2-.126",
    transform: "translate(-455.002 -472.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_221",
    "data-name": "Caminho 221",
    d: "M603.263,522.61l-.526.9a1.032,1.032,0,0,1-.964.54l-.836-.014.242-.8h.162a.456.456,0,0,0,.2-.028.223.223,0,0,0,.106-.094l.308-.49Z",
    transform: "translate(-566.56 -507.602)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionPay);
export default __webpack_public_path__ + "static/media/union-pay.26ef33bc6ee4d2fb65ebb501cf1d22e1.svg";
export { ForwardRef as ReactComponent };